module.exports = __webpack_public_path__ + "img/browserDefault.8a7c0158.svg";